import { useRef } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PropTypes from 'prop-types';
import { ACEPTAR, DIAS_CONSERVACION } from './adjuntos';

// Clip que abre el selector de archivos (imágenes y PDF) y entrega lo elegido a onArchivos.
// Todo va en un solo elemento para que, dentro de un Stack, no se cuele un hueco por el input oculto.
const BotonAdjuntar = ({ onArchivos, disabled, sx }) => {
  const inputRef = useRef(null);

  const alElegir = (e) => {
    const elegidos = Array.from(e.target.files || []);
    e.target.value = ''; // permite volver a elegir el mismo archivo
    if (elegidos.length) onArchivos(elegidos);
  };

  return (
    <Tooltip title={`Adjuntar imagen o PDF (se conservan ${DIAS_CONSERVACION} días)`}>
      <span style={{ display: 'inline-flex' }}>
        <input ref={inputRef} type="file" hidden multiple accept={ACEPTAR} onChange={alElegir} />
        <IconButton
          aria-label="Adjuntar imagen o PDF"
          onClick={() => inputRef.current?.click()}
          disabled={disabled}
          sx={{ color: 'text.secondary', ...sx }}
        >
          <AttachFileIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

BotonAdjuntar.propTypes = {
  onArchivos: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};

export default BotonAdjuntar;
